import { PaymentConst } from '../constants';
import { PaymentService } from '../services';

function resetPaymentLink() {
    return { type: PaymentConst.RESET_PAYMENT_LINK };
}

function resetClaimPayout() {
    return { type: PaymentConst.RESET_CLAIM_PAYOUT };
}

function fetchPaymentData(id) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return {type: PaymentConst.FETCH_PAYMENT_DATA_REQUEST}
    }

    function success(payload) {
        return {type: PaymentConst.FETCH_PAYMENT_DATA_SUCCESS, payload}
    }

    function failure(payload) {
        return {type: PaymentConst.FETCH_PAYMENT_DATA_FAILURE, payload}
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.fetchPaymentData(id);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            // Normalize network / parse failures into a standard shape so the
            // UI always has a { status, message } object to render against.
            const normalized = (error && typeof error === 'object' && 'status' in error)
                ? error
                : { status: false, message: 'A network error occurred. Please check your connection and try again.' };
            dispatch(failure(normalized));
        }
    }
}

function generatePaymentLink(id, name, email, channel) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.GENERATE_PAYMENT_LINK_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.GENERATE_PAYMENT_LINK_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.GENERATE_PAYMENT_LINK_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.generatePaymentLink(id, name, email, channel);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function confirmClaimCode(id, claimCode) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.CONFIRM_CLAIM_CODE_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.CONFIRM_CLAIM_CODE_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.CONFIRM_CLAIM_CODE_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.confirmClaimCode(id, claimCode);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function fetchBankList() {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.FETCH_BANKS_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.FETCH_BANKS_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.FETCH_BANKS_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.fetchBankList();

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function resolveBank(bankCode, accountNumber) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.RESOLVE_BANK_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.RESOLVE_BANK_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.RESOLVE_BANK_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.resolveBank(bankCode, accountNumber);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function claimPayout(id, formData) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.CLAIM_PAYOUT_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.CLAIM_PAYOUT_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.CLAIM_PAYOUT_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.claimPayout(id, formData);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function fetchVasServices() {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.FETCH_VAS_SERVICES_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.FETCH_VAS_SERVICES_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.FETCH_VAS_SERVICES_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.fetchVasServices();

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function fetchVasCategories(id) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.FETCH_VAS_CATEGORIES_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.FETCH_VAS_CATEGORIES_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.FETCH_VAS_CATEGORIES_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.fetchVasCategories(id);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function fetchVasProducts(id) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.FETCH_VAS_PRODUCTS_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.FETCH_VAS_PRODUCTS_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.FETCH_VAS_PRODUCTS_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.fetchVasProducts(id);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

function verifyVasEntity(id, entityNumber) {
    // return the promise using fetch which adds to localstorage on resolve

    function request() {
        return { type: PaymentConst.VERIFY_VAS_ENTITY_REQUEST }
    }

    function success(payload) {
        return { type: PaymentConst.VERIFY_VAS_ENTITY_SUCCESS, payload }
    }

    function failure(payload) {
        return { type: PaymentConst.VERIFY_VAS_ENTITY_FAILURE, payload }
    }

    return async function dispatch(dispatch) {

        dispatch(request());

        try {
            const res = await PaymentService.verifyVasEntity(id, entityNumber);

            if (res.status && res.data) {
                dispatch(success(res));
            } else {
                dispatch(failure(res));
            }
        } catch (err) {
            const error = await err;
            dispatch(failure(error));
        }
    }
}

export const PaymentAction = {
    fetchPaymentData,
    generatePaymentLink,
    confirmClaimCode,
    fetchBankList,
    resolveBank,
    claimPayout,
    fetchVasServices,
    fetchVasCategories,
    fetchVasProducts,
    verifyVasEntity,
    resetPaymentLink,
    resetClaimPayout
};
